import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-clock',
  standalone: true,
  templateUrl: './rt-icon-clock.component.html',
  styleUrls: ['./rt-icon-clock.component.scss']
})
export class RtIconClockComponent {
  @Input() width: number | string = 17;
  @Input() height: number | string = 17;
}
